const DISTRICTS = [
  'New York City',
  'Los Angeles Unified',
  'Chicago Public Schools',
  'Miami-Dade County',
  'Clark County',
  'Broward County',
  'Houston ISD',
  'Hillsborough County',
  'Orange County',
  'Fairfax County',
  'Palm Beach County',
  'Gwinnett County',
  'Dallas ISD',
  'Wake County',
  'Montgomery County',
  'Shelby County',
  'Charlotte-Mecklenburg',
  'Philadelphia City',
  'San Diego Unified',
  'Duval County',
  'Prince George\'s County',
  'Cypress-Fairbanks ISD',
  'Cobb County',
];

export default DISTRICTS;
